import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Switch,
  Tr,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { AddIcon } from '@chakra-ui/icons';
import AddModal from './addModal';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import UserApi from 'api/user';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { isValidUUID } from 'utils/fetchUtils';
import PageError from 'components/nopermission/PageError';

export default function PermissionGroupAssined(props) {
  const withId = props;
  // console.log(adminUserId);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [name, setName] = useState();
  const [displayOrder, setDisplayOrder] = useState();
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const { getPermissionsForModule } = usePermissions();
  const [permissions, setPermissions] = useState(null);
  const [
    fetchAssignedPermissionGroupListError,
    setFetchAssignedPermissionGroupListError,
  ] = useState(false);

  const adminUserId = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }

  // const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const permissions = getPermissionsForModule([Modules.AdminUser]);
    setPermissions(permissions);
  }, []);

  const AssignedPermissionGroupList = async () => {
    if (withId && !isValidUUID(adminUserId)) {
      setFetchAssignedPermissionGroupListError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await UserApi.ListPermissionGroupsAssigned({
        adminUserId,
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchAssignedPermissionGroupListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
        console.log('Here is list', list);
      } else {
        setFetchAssignedPermissionGroupListError(true);
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      setFetchAssignedPermissionGroupListError(true);
      console.log(err);
    }
  };

  const StatusPermissionGroup = async (
    id,
    permissionGroupId,
    userId,
    isActive
  ) => {
    console.log(permissionGroupId);
    try {
      let response = await UserApi.StatusPermissionGroupToUser({
        id,
        userId,
        permissionGroupId,
        isActive,
      });
      response = response.data;
      if (response.status_code === 200) {
        toast({
          title: response?.data?.message || 'Updated Successfully',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });

        AssignedPermissionGroupList();
      } else if (response.status_code !== 200) {
        toast({
          title: response?.message || 'Error Updating',
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
      }
      // window.location.reload();
      // console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    AssignedPermissionGroupList();
  }, [searchTerm, currentPage]);

  return fetchAssignedPermissionGroupListError ? (
    <PageError />
  ) : (
    <Flex direction='column'>
      <Flex
        px='25px'
        justify='space-between'
        mb='20px'
        align='center'>
        <Text
          pr='20px'
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'>
          Assigned Permission Groups
        </Text>
        {permissions?.read && permissions?.create && (
          <Flex ml='auto'>
            <AddModal
              Icon={<AddIcon />}
              head={'Assign Permission Group'}
              adminUserId={adminUserId}
              func={AssignedPermissionGroupList}
            />
          </Flex>
        )}
      </Flex>
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Sr.no
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Permission Group Name
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Last Updated
                </Flex>
              </Th>
              {/* <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Status
                </Flex>
              </Th> */}
              <Th
                pe='24px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  justifyContent='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Disable / Enable
                </Flex>
              </Th>
              {/* <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th> */}
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {index + 1}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.group_name}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Text
                      me='10px'
                      color={textColor}
                      fontSize='sm'
                      fontWeight='700'>
                      {moment(obj.updated_at).format('DD MMM YY, HH:mm')}
                    </Text>
                  </Td>
                  {/* <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={obj.is_active ? 'green' : 'red'}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.is_active ? 'Active' : 'InActive'}
                      </Text>
                    </Flex>
                  </Td> */}
                  <Td>
                    <Flex justify='center'>
                      <Switch
                        isChecked={obj.is_active}
                        disabled={!permissions?.update}
                        onChange={(e) =>
                          StatusPermissionGroup(
                            obj.id,
                            obj.group_id,
                            obj.user_id,
                            e.target.checked
                          )
                        }
                        colorScheme='teal'
                      />
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
